import toSnakeCase from "to-snake-case";

import { DEFAULT_VARIATION_FOR_OLD_MODULE_TYPES } from "~constants";

const DECOMMISSIONED_VARIATION_OVERRIDE: {
    [key: string]: Record<string, string>;
} = {
    links: {
        citylab_lines: "default",
        lines: "default",
    },
    single_story: {
        homepage_lede_with_dek_opinion: "homepage_lede_with_dek",
        homepage_lede_opinion: "homepage_lede_with_dek",
        artifact: "citylab_vertical",
    },
    story_package: {
        citylab_4_up_images: "4_up_images",
    },
    section_front_header: {
        bbgreen: "default",
        image_no_text: "default",
    },
    story_list: {
        simple_opinion: "simple",
    },
};

export function getModuleVariationOverride(variation: string, type: string) {
    const variationEditDash = toSnakeCase(variation || "");

    if (DEFAULT_VARIATION_FOR_OLD_MODULE_TYPES[type] && !variation) {
        return DEFAULT_VARIATION_FOR_OLD_MODULE_TYPES[type];
    }

    // ENG4WCP-4018: This block of code and constant should be removed after the modules are decommissioned in Curator
    if (type in DECOMMISSIONED_VARIATION_OVERRIDE) {
        if (variation in DECOMMISSIONED_VARIATION_OVERRIDE[type]) {
            return DECOMMISSIONED_VARIATION_OVERRIDE[type][variation];
        }
    }

    return variationEditDash || "default";
}

export default function getVariation(
    moduleVariation: string,
    moduleType: string
) {
    /**
     * @deprecated Curation 2025
     * TODO: After /published/[pageId]/index.tsx is live, we can remove getModuleVariationOverride and inline
    //  * const variationEditDash = toSnakeCase(variation || "");
    //  * return variationEditDash || "default";
     */
    const variantOverride = getModuleVariationOverride(
        moduleVariation,
        moduleType
    );

    return { variation: variantOverride, type: moduleType };
}
